export const topics = [
  {
    id: "topic-1",
    title: "破除羞耻：性健康心理专题",
    cover:
      "https://readdy.ai/api/search-image?query=calm%20hopeful%20abstract%20illustration%20of%20warm%20light%20breaking%20through%20soft%20teal%20mist%2C%20healing%20wellness%20editorial%20style&width=1200&height=800&seq=topic-01&orientation=landscape",
    intro:
      "羞耻感常常比行为本身更让人痛苦。这个专题从心理层面出发，陪你理解情绪的来处，一步步学会与自己和解。",
    reason:
      "如果你曾因为某些念头或感受而自责，这个专题会告诉你：你并不孤单，感受可以被理解，也值得被温柔对待。",
    articleIds: ["psychology-2", "psychology-3", "psychology-5", "psychology-10", "psychology-1"],
    tags: ["心理", "自我接纳"],
  },
  {
    id: "topic-2",
    title: "身心平衡：科学认识自慰",
    cover:
      "https://readdy.ai/api/search-image?query=balanced%20abstract%20illustration%20of%20intertwined%20teal%20and%20warm%20amber%20shapes%2C%20scientific%20wellness%20editorial%20style&width=1200&height=800&seq=topic-02&orientation=landscape",
    intro:
      "用科学代替猜测，用理解代替恐惧。这个专题汇集了关于自慰的常见问题与权威解读，帮你建立清晰、可靠的认知。",
    reason:
      "面对纷杂的信息，可靠的答案往往最难得。这里的内容基于科学研究与临床共识，适合想认真了解的你。",
    articleIds: ["science-1", "science-3", "science-8", "psychology-1", "psychology-6"],
    tags: ["科学", "认知"],
  },
  {
    id: "topic-3",
    title: "温柔待己：自我关怀入门",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20abstract%20illustration%20of%20soft%20teal%20curves%20and%20peach%20light%2C%20self%20care%20wellness%20editorial%20style&width=1200&height=800&seq=topic-03&orientation=landscape",
    intro:
      "自我关怀是一种可以练习的能力。这个专题从睡眠、情绪到求助，给你一套温柔又实用的日常方法。",
    reason:
      "不需要等到状态很差才开始照顾自己。现在就可以，从一个小习惯出发，慢慢找回身心的平衡。",
    articleIds: ["selfcare-1", "selfcare-2", "selfcare-3", "selfcare-5", "selfcare-10"],
    tags: ["关怀", "习惯"],
  },
  {
    id: "topic-4",
    title: "私密健康护理指南",
    cover:
      "https://readdy.ai/api/search-image?query=clean%20calm%20abstract%20illustration%20of%20soft%20teal%20water%20and%20warm%20cream%20tones%2C%20hygiene%20wellness%20editorial%20style&width=1200&height=800&seq=topic-04&orientation=landscape",
    intro:
      "合理的护理其实很简单。这个专题整理了几条温和、科学的身体照护知识，帮你避开过度护理的误区。",
    reason:
      "身体值得被认真、科学地照料。少一点焦虑，多一点正确的方法，就能让日常更安心。",
    articleIds: ["body-1", "body-2", "body-4", "body-5", "body-9"],
    tags: ["身体", "护理"],
  },
];